import React from 'react';
import { useAuth } from './AuthContext';
import { Wallet, TrendingUp, Shield, BarChart3 } from 'lucide-react';

export default function LoginPage() {
  const { signInWithGoogle } = useAuth();

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100 flex">
      {/* Sol Panel - Bilgi */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-neutral-900 to-neutral-950 p-12 flex-col justify-between">
        <div>
          <div className="flex items-center gap-3 mb-16">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center">
              <Wallet className="w-6 h-6 text-neutral-950" />
            </div>
            <span className="text-2xl font-bold text-neutral-50">Barbarians Portfolio Tracker</span>
          </div>

          <h1 className="text-4xl font-bold text-neutral-50 mb-6 leading-tight">
            Yatırımlarınızı<br />
            <span className="text-amber-500">Profesyonelce</span> Takip Edin
          </h1>

          <p className="text-neutral-400 text-lg mb-12">
            Hisse senetleri, kripto paralar ve daha fazlasını tek bir yerden yönetin.
          </p>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center flex-shrink-0">
                <TrendingUp className="w-5 h-5 text-amber-500" />
              </div>
              <div>
                <h3 className="font-semibold text-neutral-100 mb-1">Gerçek Zamanlı Fiyatlar</h3>
                <p className="text-neutral-500 text-sm">Hisse ve kripto için anlık fiyat takibi</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center flex-shrink-0">
                <BarChart3 className="w-5 h-5 text-amber-500" />
              </div>
              <div>
                <h3 className="font-semibold text-neutral-100 mb-1">Finansal Analiz</h3>
                <p className="text-neutral-500 text-sm">Beta, Sharpe Ratio, Volatilite ve daha fazlası</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center flex-shrink-0">
                <Shield className="w-5 h-5 text-amber-500" />
              </div>
              <div>
                <h3 className="font-semibold text-neutral-100 mb-1">Güvenli & Özel</h3>
                <p className="text-neutral-500 text-sm">Verileriniz şifreli ve sadece size özel</p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-neutral-600 text-sm">© 2025 Barbarians Portfolio Tracker. Tüm hakları saklıdır.</p>
      </div>

      {/* Sağ Panel - Login */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* Mobil Logo */}
          <div className="lg:hidden flex items-center gap-3 mb-12 justify-center">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center">
              <Wallet className="w-6 h-6 text-neutral-950" />
            </div>
            <span className="text-2xl font-bold text-neutral-50">Barbarians Portfolio Tracker</span>
          </div>

          <div className="bg-neutral-900/50 backdrop-blur-sm rounded-3xl p-8 border border-neutral-800/50">
            <h2 className="text-2xl font-bold text-neutral-50 mb-2 text-center">Hoş Geldiniz</h2>
            <p className="text-neutral-500 text-center mb-8">Devam etmek için giriş yapın</p>

            <button
              onClick={signInWithGoogle}
              className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-neutral-800 hover:bg-neutral-700 border border-neutral-700 hover:border-neutral-600 text-neutral-100 font-medium rounded-2xl transition-all duration-200"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Google ile Giriş Yap
            </button>

            <p className="text-neutral-600 text-xs text-center mt-6">
              Giriş yaparak Kullanım Şartlarını ve Gizlilik Politikasını kabul etmiş olursunuz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
